import { AxiosError } from 'axios';
import { CommandResult, FormApiService, ItemCommandResult } from 'src/common/api-service';
import { Experience } from '../person-profile/types';
import { PersonPublicSimulationInfo } from './types';

export interface RequestAccessToPersonSimulatorInput {
  age: number;
  jobs2LiveJobRoleId: string;
  currentAnnualGrossSalary: number;
  experience: Experience;
  email: string;
  origin?: string;
  isTest?: boolean;
}
export interface PublicPersonSimulatorInput extends RequestAccessToPersonSimulatorInput {
  selfEmployed: boolean;
}

export class PublicPersonSimulatorApiService extends FormApiService {
  constructor() {
    super('publicPersonSimulator');
  }

  public async requestAccess(body: RequestAccessToPersonSimulatorInput): Promise<CommandResult> {
    try {
      return await this.post<RequestAccessToPersonSimulatorInput, CommandResult>(body, 'requestAccess');
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async visit(id: string): Promise<CommandResult> {
    try {
      return await this.put<any, CommandResult>({}, `${encodeURIComponent(id)}/visit`);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performLastSimulation(accessId: string): Promise<ItemCommandResult<PersonPublicSimulationInfo>> {
    try {
      return await this.post<null, ItemCommandResult<PersonPublicSimulationInfo>>(
        null as any,
        `repeatLastSimulation/${encodeURIComponent(accessId)}`
      );
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<PersonPublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performSimulation(accessId: string, body: PublicPersonSimulatorInput): Promise<ItemCommandResult<PersonPublicSimulationInfo>> {
    try {
      return await this.post<PublicPersonSimulatorInput, ItemCommandResult<PersonPublicSimulationInfo>>(
        body,
        `performSimulation/${encodeURIComponent(accessId)}`
      );
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<PersonPublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }

  public async performRandomSimulation(selfEmployed: boolean): Promise<ItemCommandResult<PersonPublicSimulationInfo>> {
    try {
      return await this.post<null, ItemCommandResult<PersonPublicSimulationInfo>>(
        null as any,
        `performRandomSimulation?selfEmployed=${encodeURIComponent(selfEmployed)}`
      );
    } catch (e) {
      const axiosError = e as AxiosError<ItemCommandResult<PersonPublicSimulationInfo>>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
